import React from 'react'

export default function Error() {
  return (
    <div><iframe src="https://giphy.com/embed/XdK9IKZnvCrO5sCndb" width="480" height="360" frameBorder="0" class="giphy-embed" allowFullScreen></iframe><p><a href="https://giphy.com/gifs/XdK9IKZnvCrO5sCndb"></a></p></div>
  )
}

